module.exports = __webpack_public_path__ + "img/plug.a535837a.svg";